import React from "react"
import PropTypes from "prop-types"

// this is just comprises just the visible part of a Widget
// wrap it in another component or div to add padding and control responsive behavior
/** @deprecated **/
const WidgetWrapper = ({ title, narrow, extraStyles, children, childrenBgColor }) => {
  const horizontalPadding = narrow ? "ph4-ns" : "ph35-ns"
  const childrenWrapperClasses = childrenBgColor ? childrenBgColor : "bg-white"
  return (
    <div className={`w-100 h-10 ${extraStyles}`}>
      {title ? (
        <div className={`w-100 ${horizontalPadding} ph3 black`}>
          <h1 className="normal publico-headline b">{title}</h1>
        </div>
      ) : null}
      <div className={childrenWrapperClasses}>{children}</div>
    </div>
  )
}

WidgetWrapper.propTypes = {
  extraStyles: PropTypes.string,
  title: PropTypes.string,
  titleBackground: PropTypes.string
}

export default WidgetWrapper
